import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Home from './Home/Home';
import { DashHome, DashDetail } from './Dashboard';

import { CommitteeForm, ShokSamacharForm, MatrimonyForm, Achivementform, Suzhavform, DonationForm, DharmashalaBookingFrom, CreatLaga, GatividhiyaForm } from '../Forms';
import LandingPage from './Home/LandingPage';
import HomeRegistationForm from './Home/homeRegistation';
import PrivateRoute from './PrivateRoute';
import PrivacyPolicy from './Home/PrivacyPolicy';
import PublickRout from './PublickRout';
import SamajCalenderForm from '../Forms/samajCalenderForm';
import { AdminDetails, } from './admin';
import AdminRoute from "./AdminRoute"
import MemberQrViewPage from './Home/memberQrViewPage';
import AdminHomePage from './admin/AdminHomePage';
import ThemDetails from './Thems/ThemDetails';
import MatrimonyQrView from './Thems/matrimonyQrView';
import MatrimonyShearQrView from './Thems/MatrimonyShearQrView';
import NewsForm from '../Forms/NewsForm';
import Committee from './Dashboard/DashPages/Committee';
import GalleryForm from '../Forms/galleryForm';
import SamajEntryQrScan from './Home/samajEntryQrScan';
import SamelanEntryRoute from './SamelanEntryRoute';
import SamelanEntryDetails from './samelanEntry/samelanDetail';
import SamelanEntryHomePage from './samelanEntry/samelanHome';
import GuestRoute from './GuestRoute';




export default function Nav() {
    // const [isAuthenticated, setIsAuthenticated] = useState(sessionStorage.getItem('access_token'));
    const isAuthenticated = useSelector(state => state?.auth?.isLogin);

    return (
        <>
            {/* <PageRefesh /> */}
            <Routes>
                <Route element={<PublickRout />}>
                    <Route path="/" exact element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <Home />} />
                    {/* <Route path="/Privacypolicy" element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <PrivacyPolicy />} /> */}
                    <Route path="/first/registration" exact element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <HomeRegistationForm />} />
                    {/* <Route path="/committee" exact element={<Committee />} /> */}
                    <Route path="*" exact element={<LandingPage />} />
                </Route>

                {/* <Route element={<GuestRoute />}>
                    /dashboard/Suzhav
                    <Route path="/Committee" exact element={<CommitteeForm />} />
                    <Route path="/dashboard" exact element={<DashHome />} />
                    <Route exact path="/dashboard/:section" element={<DashDetail />} />
                    <Route path="/dashboard/dharmashalaBooking" element={<DharmashalaBookingFrom />} />
                    <Route path="/dashboard/newSuzhav" element={<Suzhavform />} />
                    <Route path="/them/:them" element={<ThemDetails />} />
                </Route> */}



                {/* Private routes accessible only when authenticated */}
                <Route>
                    <Route path="/Privacypolicy" exact element={<PrivacyPolicy />} />
                    <Route path="/matrimony/registration" exact element={<MatrimonyForm />} />
                    <Route path="/memberQr/:memberShipCode/" exact element={<MemberQrViewPage />} />
                    <Route path="/matrimonyQr/:matCode" element={<MatrimonyQrView />} />
                    <Route path="/QR/:token" element={<MatrimonyShearQrView />} />
                    {/* <Route path="/entry/QR/:matCode" element={<SamajEntryQrScan />} /> */}
                </Route>

                {/* Admin routes accessible only for admin */}
                <Route path="/admin" element={<AdminRoute />}>
                    <Route path=":pages" exact element={<AdminDetails />} />
                    <Route path="" element={<AdminHomePage />} />
                    {/* <Route path=":pages" element={<UserManagement />} /> */}
                    <Route path="news" element={<NewsForm />} />
                    <Route path="addgallery" exact element={<GalleryForm />} />
                    {/* <Route path="addgallery" exact element={<GalleryForm />} /> */}
                    {/* <Route path="addDonation" element={<DonationForm />} />
                    <Route path="calender" element={<SamajCalenderForm />} />
                    <Route path="achivement" element={<Achivementform />} />
                    <Route path="creatLaga" element={<CreatLaga />} /> */}
                    <Route path="newGativithi" element={<GatividhiyaForm />} />
                    {/* <Route path="dharmashalaBooking" element={<DharmashalaBookingFrom />} /> */}
                    {/* <Route path="matrimony/registration" element={<MatrimonyForm />} /> */}
                </Route>

                <Route path="/" element={<PrivateRoute />}>
                    {/* /dashboard/Suzhav */}
                    <Route path="/Committee" exact element={<CommitteeForm />} />
                    <Route path="/dashboard" exact element={<DashHome />} />
                    <Route exact path="/dashboard/:section" element={<DashDetail />} />
                    <Route path="/dashboard/dharmashalaBooking" element={<DharmashalaBookingFrom />} />
                    <Route path="/dashboard/newSuzhav" element={<Suzhavform />} />
                    <Route path="/them/:them" element={<ThemDetails />} />
                </Route>

                <Route path="/samelan" element={<SamelanEntryRoute />}>
                    <Route path=":pages" exact element={<SamelanEntryDetails />} />
                    <Route path="" element={<SamelanEntryHomePage />} />
                </Route>

            </Routes>
        </>
    );
}
